"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resourcesCommonPath = exports.resourcesPath = exports.subDirOfPublicDirBasename = void 0;
var pathJoin_1 = require("../../tools/pathJoin");
exports.subDirOfPublicDirBasename = "keycloak_static";
exports.resourcesPath = (0, pathJoin_1.pathJoin)(exports.subDirOfPublicDirBasename, "resources");
exports.resourcesCommonPath = (0, pathJoin_1.pathJoin)(exports.resourcesPath, "resources_common");
//# sourceMappingURL=urlResourcesPath.js.map